import React from 'react';
import { Skeleton, Button, Modal } from 'antd';
import { FormattedMessage } from 'react-intl';
import { useSelector } from 'react-redux';
import styles from './CandidateCardTertiaryContent.module.scss';
import CandidateCardNotesIcon from './CandidateCardNotesIcon';
import SocialIcon from '../Common/SocialIcon/SocialIcon';
import CandidateCardConnectOptions from './CandidateCardConnectOptions';
import { getCurrentUser } from '../../Reducers/UserSessionReducer';
import { getConfig } from '../../Reducers/ConfigReducer';
import { getCandidateApplicationPreviewBtn } from '../CandidateListItem/CandidateListItem';
import message from '../Placeholders/PlaceholdersMessages';
import ScheduleInterviewButton from './ScheduleInterviewButton';

function CandidateCardTertiaryContent(props) {
  const {
    onCandidateCardClick,
    candidate,
    maskingConfig,
    candidateContext,
    featureToggleList,
    connectStatusLoaded,
    showCandidateDetail,
    setComposeEmailType,
    indexKey,
    currentJobDetails,
    handleContactPull,
    showConnectWidget,
    status,
    candidateType,
    version,
    isCandidateViewIconVisible,
    isUndoModalVisible,
    setUndoModalVisibility,
    undoPortalApply,
  } = props;

  const currentUser = useSelector(state => getCurrentUser(state));
  const userConfig = useSelector(state => getConfig(state));
  const jobGuid = currentJobDetails?.JobGuid;
  const candidateApplicationPreviewButton = getCandidateApplicationPreviewBtn(
    jobGuid,
    candidate,
    featureToggleList,
    currentUser,
    userConfig
  );
  const isUndoAppliedEnabled =
    featureToggleList?.UndoCandidateApplication?.IsEnabled && status?.toLowerCase() === 'applied';
  const applicationPreviewBtn = candidateApplicationPreviewButton || null;

  const onUndoPortal = () => {
    undoPortalApply(currentJobDetails.JobGuid, candidate.Id);
    setUndoModalVisibility(false);
  };

  const isScheduleInterviewVisible =
    featureToggleList?.ScheduleInterviewByUser?.IsEnabled &&
    (!!candidate?.AppliedTime || candidate?.ConnectionStatus?.toLowerCase() === 'connected');

  return (
    <Skeleton active loading={!connectStatusLoaded} rows={1} title={false}>
      <div className={styles.candidateCardTertiaryContent}>
        {isScheduleInterviewVisible ? (
          <ScheduleInterviewButton candidate={candidate} userEmail={currentUser?.email} />
        ) : null}
        {applicationPreviewBtn}
        {isUndoAppliedEnabled ? (
          <Button
            type="link"
            onClick={e => {
              e.stopPropagation();
              setUndoModalVisibility(true);
            }}
            className={styles.linkButton}
          >
            <FormattedMessage {...message.undoApplyLabel} />
          </Button>
        ) : (
          <></>
        )}
        {candidateContext !== 'candidateCreation' && (
          <CandidateCardNotesIcon
            onCandidateCardClick={onCandidateCardClick}
            candidate={candidate}
            featureToggleList={featureToggleList}
            candidateType={candidateType}
            version={version}
          />
        )}
        <SocialIcon candidate={candidate} isActive={maskingConfig?.IsActive} />
        <CandidateCardConnectOptions
          featureToggleList={featureToggleList}
          connectStatusLoaded={connectStatusLoaded}
          showCandidateDetail={showCandidateDetail}
          setComposeEmailType={setComposeEmailType}
          candidate={candidate}
          indexKey={indexKey}
          currentJobDetails={currentJobDetails}
          handleContactPull={handleContactPull}
          showConnectWidget={showConnectWidget}
          candidateContext={candidateContext}
          isCandidateViewIconVisible={isCandidateViewIconVisible}
        />

        <div
          role="presentation"
          onClick={e => {
            e.stopPropagation();
          }}
        >
          <Modal
            visible={isUndoModalVisible}
            onCancel={() => {
              setUndoModalVisibility(false);
            }}
            okText="Confirm"
            okButtonProps={{ shape: 'round' }}
            cancelButtonProps={{ shape: 'round' }}
            onOk={onUndoPortal}
            closable={false}
          >
            <div className={styles.undoModalContent}>
              <FormattedMessage {...message.requestToWithdrawYourJobApplicationLabel} />
            </div>
          </Modal>
        </div>
      </div>
    </Skeleton>
  );
}

export default CandidateCardTertiaryContent;
